module.exports = __webpack_public_path__ + "img/ribbon-red.338c6b66.png";